// extracted by mini-css-extract-plugin
export default {"content":"Gallery_content__rlY5Y","h1":"Gallery_h1__vP2uG","row":"Gallery_row__Zqilo","img":"Gallery_img__kVzGn"};